import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Gift, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function ReferralCard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referral").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const link = `${window.location.origin}/?ref=${data.code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Referral link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy — select and copy manually");
    }
  };

  return (
    <div data-testid="referral-card" className="rounded-2xl border border-border bg-card p-6">
      <div className="flex items-start gap-3 mb-4">
        <div className="h-10 w-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
          <Gift className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h3 className="font-heading font-bold">Give friends {data.referral_trial_days} days free</h3>
          <p className="text-sm text-muted-foreground">
            Share your link — anyone who signs up gets an extended {data.referral_trial_days}-day trial (instead of {data.trial_days}).
            {data.referred_count > 0 && <span className="text-foreground font-semibold"> You've referred {data.referred_count} so far.</span>}
          </p>
        </div>
      </div>
      <div className="flex gap-2">
        <Input data-testid="referral-link-input" readOnly value={link} className="rounded-xl font-mono-num text-sm" />
        <Button data-testid="referral-copy-button" onClick={copy} className="rounded-xl bg-primary text-primary-foreground hover:bg-primary/90 shrink-0">
          {copied ? <Check className="h-4 w-4 mr-1.5" /> : <Copy className="h-4 w-4 mr-1.5" />} {copied ? "Copied" : "Copy"}
        </Button>
      </div>
    </div>
  );
}
